class ExitIntentPopup extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    this.formView = this.querySelector('[data-exit-intent-form-view]');
    this.successView = this.querySelector('[data-exit-intent-success-view]');
    this.errorEl = this.querySelector('[data-exit-intent-error]');
    this.closeBtn = this.querySelector('.exit-intent__close');
    this.storageKey = 'exit_intent_dismissed';
    this.shown = false;
    this.mouseLeaveHandler = this.handleMouseLeave.bind(this);
    this.config = {
      delayDays: parseInt(this.dataset.delayDays, 10) || 7,
      mobileFallback: this.dataset.mobileFallback === 'true',
      mobileDelaySeconds: parseInt(this.dataset.mobileDelay, 10) || 45,
    };
  }

  connectedCallback() {
    if (this.dataset.enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (this.isDismissed()) return;
    if (this.isExcludedPage()) return;

    this.closeBtn?.addEventListener('click', () => this.close(true));
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close(true);
    });
    this.dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close(true);
    });
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    this.waitForCookieConsent().then(() => this.setupTriggers());
  }

  disconnectedCallback() {
    document.removeEventListener('mouseleave', this.mouseLeaveHandler);
  }

  isExcludedPage() {
    const path = window.location.pathname;
    return (
      path.includes('/cart') ||
      path.includes('/checkout') ||
      path.includes('/account') ||
      path.includes('/password')
    );
  }

  isDismissed() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (!stored) return false;
      const data = JSON.parse(stored);
      const expiry = data.timestamp + data.days * 24 * 60 * 60 * 1000;
      return Date.now() < expiry;
    } catch {
      return false;
    }
  }

  setDismissed() {
    localStorage.setItem(
      this.storageKey,
      JSON.stringify({
        timestamp: Date.now(),
        days: this.config.delayDays,
      })
    );
  }

  waitForCookieConsent() {
    return new Promise((resolve) => {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner || banner.hidden) {
        resolve();
        return;
      }

      let resolved = false;
      const done = () => {
        if (resolved) return;
        resolved = true;
        setTimeout(resolve, 500);
      };

      ['shopify-pc__banner__btn-accept', 'shopify-pc__banner__btn-decline', 'shopify-pc__banner__btn-manage-prefs'].forEach(
        (id) => {
          const button = document.getElementById(id);
          if (button) button.addEventListener('click', done, { once: true });
        }
      );

      setTimeout(done, 30000);
    });
  }

  setupTriggers() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile) {
      if (this.config.mobileFallback) {
        setTimeout(() => this.show(), this.config.mobileDelaySeconds * 1000);
      }
      return;
    }

    document.addEventListener('mouseleave', this.mouseLeaveHandler);
  }

  handleMouseLeave(event) {
    if (event.clientY > 0) return;
    this.show();
  }

  show() {
    if (!this.dialog || this.dialog.open || this.shown) return;
    this.shown = true;
    document.removeEventListener('mouseleave', this.mouseLeaveHandler);
    this.dialog.showModal();
  }

  close(dismiss) {
    if (!this.dialog?.open) return;
    this.dialog.close();
    if (dismiss) this.setDismissed();
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.classList.remove('hidden');
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.classList.add('hidden');
  }

  showSuccess() {
    this.hideError();
    this.formView?.classList.add('hidden');
    this.successView?.classList.remove('hidden');
  }

  getContactUrl() {
    if (this.form?.action) return this.form.action;
    const root = window.Shopify?.routes?.root || '/';
    return `${root}contact`;
  }

  buildFormData() {
    const formData = new FormData(this.form);
    formData.delete('exit-intent-consent');
    return formData;
  }

  handleSubmit(event) {
    event.preventDefault();
    this.hideError();

    const consent = this.form.querySelector('[name="exit-intent-consent"]');
    if (consent && !consent.checked) {
      this.showError(this.dataset.consentError || 'Bitte stimmen Sie dem Erhalt von Marketing-E-Mails zu.');
      return;
    }

    const submitButton = this.form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    fetch(this.getContactUrl(), {
      method: 'POST',
      body: this.buildFormData(),
      credentials: 'same-origin',
      redirect: 'follow',
    }).catch(() => {});

    this.showSuccess();
    this.setDismissed();

    if (submitButton) submitButton.disabled = false;
  }

}

if (!customElements.get('exit-intent-popup')) {
  customElements.define('exit-intent-popup', ExitIntentPopup);
}
